<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="p0005-01-0">C<span class="small">ONTENTS</span></p>
<p class="cct1"><a href="#/Chapter2">Chapter One</a></p>
<p class="cct1"><a href="#/Chapter3">Chapter Two</a></p>
<p class="cct1"><a href="#/Chapter4">Chapter Three</a></p>
<p class="cct1"><a href="#/Chapter5">Chapter Four</a></p>
<p class="cct1"><a href="#/Chapter6">Chapter Five</a></p>
<p class="cct1"><a href="#/Chapter7">Chapter Six</a></p>
<p class="cct1"><a href="#/Chapter8">Chapter Seven</a></p>
<p class="cct1"><a href="#/Chapter9">Chapter Eight</a></p>
<p class="cct1"><a href="#/Chapter10">Chapter Nine</a></p>
<p class="cct"><a href="#/Chapter11">An Excerpt from <i>A New Chapter</i></a></p>
<p class="cct"><a href="#/Chapter15">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?69333988